import { apiClient, Auth } from '@/shared/api'

import { TRoomDescription } from '../model/schema'

export type RoomDescriptionParams = {
  roomId: number
}

export const getRoomDescription = async ({ roomId }: RoomDescriptionParams) => {
  const response = await apiClient.get<TRoomDescription>({
    endpoint: `/host/rooms/${roomId}/description`,
    auth: Auth.REQUIRED,
  })

  return response
}
